<script>
    import {getGPTransFunc} from "./gp-translations.js";
    let trans = getGPTransFunc("gp-labeldialog");
    import jQuery from "jquery";
    import {onMount} from "svelte";
    import {GPLabel} from "./gp-label.js";
    import {selectedLabel} from "./gp-context-labels.js";
    import {selectedItemSet} from "./gp.js";
    import {fly} from "svelte/transition"

    let originItemInstance = null;
    let editedItemInstance = null;
    let labelText = "";
    let editing = false;
    $: if ($selectedLabel) show($selectedLabel);

    onMount(()=>{
        //manage focus
        jQuery('#GPLabelDialog').on('show.bs.collapse', GP.storeFocus);
        jQuery('#GPLabelDialog').on('shown.bs.collapse',function (){jQuery('#GPAddLabelTitle').focus()});
        jQuery('#GPLabelDialog').on('hidden.bs.collapse', GP.restoreFocus);

    })

    function show (p_item) {
        if (p_item instanceof GPLabel) {
            editedItemInstance = p_item;
            originItemInstance = p_item.originItemInstance;
            labelText = p_item.text;
            editing = true;
        } else {
            originItemInstance = p_item;
            editedItemInstance = null;
            labelText = p_item.getName();
            editing = false;
        }
    }


    function addLabel () {
        if (!editedItemInstance)
            GP.addLabel(originItemInstance, labelText);
        else
            GP.updateLabel(editedItemInstance, labelText);
        $selectedLabel = false;
    }

    function removeLabel() {
        GP.removeLabel(editedItemInstance);
        $selectedLabel = null;
        $selectedLabel = false;
    }

</script>

{#if $selectedLabel}
<div id="GPLabelDialog" class:offsetted={$selectedItemSet.length} transition:fly="{{ x: 200 }}">
    <div class="">{trans("Label")}</div>
    <div class="labelDialogActions">
        <input bind:value={labelText} class="form-control" placeholder='{trans("Your label")}' type="text" id="GPAddLabelTitle" name="gpaddlabel" required>
        {#if editing}
            <button on:click={addLabel} type="button" class="btn btn-default GPAddLabelConfirm" id="save">{trans("Save")} </button>
        {:else}
            <button on:click={addLabel} type="button" class="btn btn-default GPAddLabelConfirm" id="add">{trans("Add")} </button>
        {/if}
    </div>
    {#if editing}<div class="labelDialogActionsRemove"><a on:click={removeLabel}>{trans("Delete")}</a></div>{/if}
    <a on:click={()=>{$selectedLabel=null}} href="#" class="btn closeBtn" role="button"><i class="fa fa-times fa-sg"></i></a>
</div>
{/if}